import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteEmailCredentialPayload } from '@app-store/slices/emailCredential/delete'

interface TaskAction extends Action {
    payload: IDeleteEmailCredentialPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.emailCredential.delete

function* deleteEmailCredentialSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/notifications/email-credentials/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(rootActions.emailCredential.list.onRemoveItem(payload.id))
            notification.success({
                message: 'Email deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteEmailCredentialSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteEmailCredentialSagaTask)
}

export default deleteEmailCredentialSaga
